export const REGEXPS = {
  Guid: /[0-9A-Fa-f]{8}(?:-[0-9A-Fa-f]{4}){3}-[0-9A-Fa-f]{12}/,
  AddressFullFlat: /,\s*кв.*$/,
  AddressFlat: /,\s?кв\.?\s?/,
  AddressPostalCode: /^\d{6},*\s/,
};
